import { render } from "./login.vue?vue&type=template&id=cb6d2e56&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=cb6d2e56&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6d2e56"]])

export default __exports__